export enum FeatureFlag {
    Premium = 'premium',
    Invoicing = 'invoicing',
}
